








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'WeekSelect' })
export default class WeekSelect extends Vue {
  private weekOptions: any[] = [
    { label: '星期一', value: '1', key: '1' },
    { label: '星期二', value: '2', key: '2' },
    { label: '星期三', value: '3', key: '3' },
    { label: '星期四', value: '4', key: '4' },
    { label: '星期五', value: '5', key: '5' },
    { label: '星期六', value: '6', key: '6' },
    { label: '星期日', value: '7', key: '7' },
  ];

  /** 禁用 */
  @Prop({ default: false })
  private disabled: boolean;

  /** 提示占位符 */
  @Prop({ default: '星期' })
  private placeholder: string;

  /** 宽度 */
  @Prop({ default: '80px' })
  private width: string;

  /** 值 */
  @Prop()
  private value: string;

  /** 获取值 */
  get currentValue(): string {
    return this.value;
  }

  /** 返回值 */
  set currentValue(value: string) {
    this.$emit('input', value);
  }
}
